"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_i18next_1 = require("react-i18next");
const webview_app_1 = require("@/webview_app");
const functions_1 = require("@/common/functions");
const Dialog_1 = __importDefault(require("@mui/material/Dialog"));
const Button_1 = __importDefault(require("@mui/material/Button"));
const styled_1 = __importDefault(require("@emotion/styled"));
const _1 = require(".");
function default_1({ open, closeDialog, }) {
    (0, webview_app_1.useAABBDialogClose)({ open, closeDialog });
    (0, functions_1.useIOSDialogCloseScrollBack)(open);
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsxs)(SettlementGuideDialog, Object.assign({ open: open }, { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "tab_subtab_wrapper" }, { children: [(0, jsx_runtime_1.jsx)(_1.SettlementGuideTab, {}), (0, jsx_runtime_1.jsx)(_1.SettlementGuideSubTab, {})] })), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "contents_wrapper" }, { children: (0, jsx_runtime_1.jsx)(_1.SettlementGuideContents, {}) })), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "confirm_btn_wrapper" }, { children: (0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ onClick: closeDialog }, { children: t('확인') })) }))] })));
}
exports.default = default_1;
const SettlementGuideDialog = (0, styled_1.default)(Dialog_1.default) `
  .MuiDialog-scrollPaper {
    align-items: flex-end;
  }
  .MuiDialog-paper {
    width: 100%;
    max-width: 480px;
    height: 90%;
    padding: 0 16px;
    border-radius: 20px 20px 0 0;
    margin: 0;
    overflow: hidden;
  }
  .tab_subtab_wrapper {
    display: flex;
    flex-direction: column;
    row-gap: 14px;
    padding: 20px 0;
    margin: 0 -20px;
  }
  .contents_wrapper {
    display: flex;
    flex-direction: column;
    height: 100%;
    padding: 0 16px 20px;
    margin: 0 -16px -20px;
    overflow: hidden auto;
  }
  .confirm_btn_wrapper {
    position: sticky;
    bottom: 0;
    padding: 20px 0 32px;
    background: linear-gradient(
      180deg,
      rgba(255, 255, 255, 0.0001) 0%,
      rgba(255, 255, 255, 0.6) 11.59%,
      #ffffff 30.42%
    );
    button {
      width: 100%;
      height: 56px;
      padding: 0 8px;
      border-radius: 12px;
      line-height: 26px;
      font-size: 18px;
      font-weight: bold;
      color: var(--white);
      background-color: var(--primary-main);
    }
  }
`;
